import { Typography } from "antd";
import { usePublicClasses } from "../../api/Classes";
import ClassCard from "../../components/Class/ClassCard";
import { ContentTitle } from "../../layout/ContentLayout";

const ClassHomepage = () => {
  return (
    <>
      <ContentTitle>Classes</ContentTitle>
      <PublicClasses />
    </>
  );
};

const PublicClasses = () => {
  let { data } = usePublicClasses();

  return (
    <>
      <Typography.Title level={4} type="secondary" className="sub-title">
        Public Classes
      </Typography.Title>
      {data?.courses?.map((c) => (
        <ClassCard key={c.CourseId} classInfo={c} />
      ))}
    </>
  );
};

export default ClassHomepage;
